import { shellStringResources } from '../../Resources/ShellStringResources';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'expressCustomSetupError',
    display: [shellStringResources.ModelName_ExpressCustomSetupError, shellStringResources.ModelName_ExpressCustomSetupErrors]
})
export class ExpressCustomSetupError {
    public dateTime: string;
    public setupName: string;
    public version: string;
    public errorCode: number;
    public shortMessage: string;
    public fullMessage: string;
}
